export const CalculateNextItemId = (
    array: any[] | undefined,
    idPropKey: string | undefined,
    currentId: string | number | undefined,
    isNext: boolean
): string | number => {
    if (array && idPropKey && currentId !== undefined) {
        const currentIndex = array.map(p => p[idPropKey]).indexOf(currentId);
        let newIndex = isNext ? currentIndex + 1 : currentIndex - 1;
        if (newIndex < 0) newIndex = array.length - 1;
        if (newIndex > array.length - 1) newIndex = 0;
        return array[newIndex][idPropKey];
    }
    return '';
};
